module.exports = __webpack_public_path__ + "static/AdlerNotesFinal-a6238d5381ba3f45bbec78cce0f076af.jpg";